import { Form, InputNumber, Key } from '@maxtropy/components';
import { Col, FormInstance, Row } from 'antd';
import { useEffect } from 'react';
import bsaImg from '../imgs/bsa@2x.png';
import styles from './index.module.scss';

// 新增独立组件
interface BsaEnergyLossFieldsProps {
  bsaOptions: Array<{ label: string; value: number }>;
  selectedBsaList?: number[];
  form: FormInstance<any>;
}

const BsaEnergyLossItem: React.FC<BsaEnergyLossFieldsProps> = ({ bsaOptions, selectedBsaList = [], form }) => {
  // 同步字段数量
  useEffect(() => {
    const currentList: Array<{ bsaId?: number }> = form.getFieldValue('bsaEnergyLossList') || [];

    // 创建目标数据结构
    const targetList = selectedBsaList.map(bsaId => {
      // 查找已存在的配置
      const exist = currentList.find(item => item.bsaId === bsaId);
      return exist || { bsaId, chargeLossRatio: undefined, dischargeLossRatio: undefined };
    });

    // 移除已经不存在的项（按 bsaId 比对）
    const finalList = targetList.filter(item => selectedBsaList.includes(item.bsaId!));

    if (JSON.stringify(finalList) !== JSON.stringify(currentList)) {
      form.setFieldValue('bsaEnergyLossList', finalList);
    }
  }, [selectedBsaList, form]);

  return (
    <Form.List name="bsaEnergyLossList">
      {fields => (
        <Row gutter={8} style={{ columnGap: 120 }}>
          {fields.map((field, index) => {
            const currentItem = form.getFieldValue(['bsaEnergyLossList', index]);
            const bsaInfo = bsaOptions.find(item => item.value === currentItem?.bsaId);

            return (
              <Col span={12} key={index} className={styles.topCol} style={{ maxWidth: 464 }}>
                <Form.Item
                  className={styles.topTitle}
                  label={
                    <div className={styles.bsaTitle}>
                      <img src={bsaImg} alt="" className={styles.icon} />
                      <span className={styles.text}>{`${bsaInfo?.label}充放电损耗`}</span>
                    </div>
                  }
                >
                  <Row gutter={8}>
                    <Col span={12} style={{ paddingRight: 8 }}>
                      <Form.Item
                        {...field}
                        label={`充电能量损耗比`}
                        name={[index, 'chargeLossRatio']}
                        rules={[{ required: true, message: '请输入充电能量损耗比' }]}
                      >
                        <InputNumber
                          placeholder="请输入"
                          min={0}
                          max={100}
                          precision={2}
                          addonAfter="%"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} style={{ paddingLeft: 8 }}>
                      <Form.Item
                        {...field}
                        label={`放电能量损耗比`}
                        name={[index, 'dischargeLossRatio']}
                        rules={[{ required: true, message: '请输入放电能量损耗比' }]}
                      >
                        <InputNumber
                          placeholder="请输入"
                          min={0}
                          max={100}
                          precision={2}
                          addonAfter="%"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            );
          })}
        </Row>
      )}
    </Form.List>
  );
};

export default BsaEnergyLossItem;
